import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface Props {
    style?: React.CSSProperties,
    onChange?: {(newValue: string) : void},
    validation: {(value: string) : boolean},
    errorMessage: string,
    value?: string,
    defaultValue?: string,
    placeholder?: string,
    id?: string,
    className?: string,
    key: string,
    placement?: "top" | "left" | "right" | "bottom"
};
interface State { 
    show: boolean,
    invalid: boolean
};

export default class ValidatedInput extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.onChange = this.onChange.bind(this);

        this.state = { 
            show: false,
            invalid: true //TODO: valudate propValue
        };
    }

    componentDidUpdate(prevProps: Props, prevState: State) {

    }

    onChange(event: React.ChangeEvent<HTMLInputElement>) {
        const valid = this.props.validation(event.target.value);

        if(this.props.onChange !== undefined)
            this.props.onChange(event.target.value);

        this.setState({invalid: !valid});
    }

    render() {
        const { style } = this.props;

        return (
            <OverlayTrigger
                key={this.props.key}
                placement={this.props.placement || "right"}
                trigger={["hover", "focus"]}
                overlay={
                    <Tooltip id={`${this.props.key}-tooltip`} hidden={!this.state.invalid}>
                        {this.props.errorMessage}
                    </Tooltip>
                }
            >
                <input 
                    className={`form-control ${this.state.invalid ? 'validated-input-has-error' : ''} ${this.props.className}`}
                    style={style}
                    type="text"
                    id={this.props.id} 
                    value={this.props.value}
                    defaultValue={this.props.defaultValue}
                    placeholder={this.props.placeholder}
                    onChange={this.onChange}
                />
            </OverlayTrigger>
        );
    }
}